// ======================================================================
// File Name       : UserSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, Button, Row } from 'react-bootstrap';
import PaginationCustom from '../Pagination';
import SelectBox from '../SelectBox';
import { convertNodeGroupToNodeString } from '../../utils/UserUtils';
import { USER_TYPE } from '../../constants/UserConstants';
import CustomButton from '../button/CustomButton';
import * as Path from '../../constants/PathConstants';
import * as FUNCTION from '../../constants/FunctionConstants';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';
import { canAccessRoute } from '../../utils/AuthedUtils';


class UserSearch extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    const shouldNotUpdate =
    nextProps.userType === this.props.userType &&
    nextProps.userName === this.props.userName &&
    nextProps.loginId === this.props.loginId &&
    nextProps.startPosition === this.props.startPosition &&
    nextProps.managementAuthoritySecernId === this.props.managementAuthoritySecernId &&
    nextProps.dormantState === this.props.dormantState &&
    nextProps.userAttributeKeyNum === this.props.userAttributeKeyNum &&
    nextProps.userAttributeSearchText === this.props.userAttributeSearchText &&
    nextProps.selectedGroup === this.props.selectedGroup &&
    nextProps.recordNum === this.props.recordNum &&
    nextProps.groupList === this.props.groupList &&
    nextProps.managementAuthorityList === this.props.managementAuthorityList &&
    nextProps.allGroupOwnerFlag === this.props.allGroupOwnerFlag;
    return !shouldNotUpdate;
  }

  render() {
    const {
      userType,
      userName,
      loginId,
      startPosition,
      managementAuthoritySecernId,
      dormantState,
      userAttributeKeyNum,
      userAttributeSearchText,
      selectedGroup,
      recordNum,
      groupList,
      managementAuthorityList,
      handleChange,
      removeSelectedGroup,
      showSelectGroupDlg,
      getStartEndData,
      onSearchBtnClick,
      onExportBtnClick,
      onLoginExportBtnClick,
      isShowLoginExportBtn,
      isSuperUser,
      allGroupOwnerFlag,
    } = this.props;

    const attributeBox = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20];
    const attributeOption = attributeBox.map(item => <option key={item} value={item}>{item}</option>);
    const groupNameString = (selectedGroup && selectedGroup.groupSecernId) ? convertNodeGroupToNodeString(selectedGroup.groupSecernId, groupList) : "";
    const canAccessImport = canAccessRoute(FUNCTION.USER_IMPORT);
    const canAccessRegister = canAccessRoute(FUNCTION.USER_REGISTER);

    return (
      <Col sm={12} className="padding-left-right-clear">
        <p className="margin-top-10">検索する項目を指定してください</p>
        <Form onSubmit={(e) => { e.preventDefault(); onSearchBtnClick(); }} className='form-horizontal'>
          <Col sm={12} className="margin-top-10 margin-bottom-10">
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>ユーザー種別</Col>
              <Col sm={9} className="padding-top-10">
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear "
                  name="userType"
                  id={`userType-${USER_TYPE.ALL}`}
                  value={USER_TYPE.ALL}
                  checked={parseInt(userType, 10) === USER_TYPE.ALL}
                  onChange={handleChange}
                  label='すべて'></Form.Check>
                <Form.Check
                  type='radio'
                  inline
                  className="padding-top-clear margin-left-30"
                  name="userType"
                  id={`userType-${USER_TYPE.STUDENT}`}
                  value={USER_TYPE.STUDENT}
                  checked={parseInt(userType, 10) === USER_TYPE.STUDENT}
                  onChange={handleChange}
                  label='受講ユーザー'></Form.Check>
                <Form.Check
                  type='radio'
                  className="margin-left-30 padding-top-clear"
                  inline
                  name="userType"
                  id={`userType-${USER_TYPE.ADMIN}`}
                  value={USER_TYPE.ADMIN}
                  checked={parseInt(userType, 10) === USER_TYPE.ADMIN}
                  onChange={handleChange}
                  label='旧管理ユーザー'></Form.Check>
              </Col>
            </Form.Group>
            <Form.Group className="form-info" controlId="formHorizontalUserName">
              <Col as={Form.Label} sm={3}>ユーザー名</Col>
              <Col sm={7}>
                <FormControl
                  type="text"
                  name="userName"
                  value={userName}
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info" controlId="formHorizontalLoginID">
              <Col as={Form.Label} sm={3}>ログインID</Col>
              <Col sm={7}>
                <FormControl
                  type="text"
                  name="loginId"
                  value={loginId}
                  onChange={handleChange}
                />
              </Col>
            </Form.Group>

            {parseInt(userType, 10) !== 0
              ? null
              : <Form.Group className="form-info">
                <Col as={Form.Label} sm={3}>権限ロール</Col>
                <Col sm={7}>
                  <SelectBox
                    value={managementAuthoritySecernId || ''}
                    valueKey="managementAuthoritySecernId"
                    nameKey="managementAuthorityName"
                    name="managementAuthoritySecernId"
                    data={managementAuthorityList}
                    onChange={handleChange}
                  />
                </Col>
              </Form.Group>}

            <Form.Group className="form-info" controlId="formHorizontalGroup">
              <Col as={Form.Label} sm={3}>ユーザーグループ名</Col>
              <Col sm={2}>
                <Button
                  variant="primary"
                  className="btn-96"
                  onClick={showSelectGroupDlg}
                >
                  グループ選択
                </Button>
              </Col>
            </Form.Group>
            {groupNameString &&
              <Form.Group className="form-info" controlId="formHorizontalGroup">
                <Col sm={3}>
                </Col>
                <Col sm={7} as={Form.Label} className="ps-0">
                  {groupNameString}
                </Col>
                <Col sm={2} className="padding-left-30">
                  <Button variant="primary" className="btn-96" onClick={removeSelectedGroup.bind(this)}>削除</Button>
                </Col>
              </Form.Group>}
            <Form.Group className="form-info">
              <Col sm={5}>
                <Form.Check
                  className="margin-left-15 margin-top-5"
                  type='checkbox'
                  name="dormantState"
                  id="dormantState"
                  onChange={handleChange}
                  checked={dormantState}
                  label='休止状態のユーザーも表示する'
                ></Form.Check>
              </Col>
            </Form.Group>
          </Col>
          <Form.Group className="margin-top-10">
            <Col sm={12} className="text-center">
              <CustomButton
                btnStyle="btn btn-primary btn-96"
                type="submit"
                iconClass="bi bi-search"
                text="検索"
              />
            </Col>
          </Form.Group>
          <Col sm={12} className="margin-bottom-15">
            <Col sm={7}>
              {/* Step 12.0.0 TAS-17580 START */}
              {/* {canAccessRegister && (
                <CustomLink
                  className="margin-right-7 btn-register margin-right-10"
                  to={Path.USER_REGISTER}
                  text="ユーザー追加"
                  icon={ICON.REGIST}
                />
              )} */}
              {/* Step 12.0.0 TAS-17580 END */}
              {canAccessImport && (
                <CustomLink
                  className="margin-right-7 btn-csv-import"
                  to={Path.USER_IMPORT}
                  text="CSV一括投入"
                  icon={ICON.IMPORT}
                />
              )}
            </Col>
            <Col sm={5} className="display-flex justify-content-end float-end">
              {((isSuperUser && allGroupOwnerFlag) || isShowLoginExportBtn) ? (
                <CustomButton
                  btnStyle="btn btn-export-csv margin-right-10"
                  handleClick={onLoginExportBtnClick}
                  iconClass="bi bi-download"
                  text="ログイン履歴CSV出力"
                />
              ) : null }
              <CustomButton
                btnStyle="btn btn-export-csv"
                handleClick={onExportBtnClick}
                iconClass="bi bi-download"
                text="一括出力"
              />
            </Col>
          </Col>
        </Form>
      </Col>
    );
  }
}

export default UserSearch;
